class OpDataTable extends HTMLElement {
  constructor() {
    super();
    this.headers = [];
    this.rows = [];
    this.filteredRows = [];
    this.activeFilters = {
      search: '',
      status: '',
      type: ''
    };
    
    // this.querySelector('#op-search')?.addEventListener('input', (e) => {
    //   this.activeFilters.search = e.target.value;
    //   this.applyFilters();
    // });
    
    // // Add dropdown filter listeners
    // this.querySelector('#status-filter')?.addEventListener('change', (e) => {
    //   this.activeFilters.status = e.target.value;
    //   this.applyFilters();
    // });
    
    // this.querySelector('#type-filter')?.addEventListener('change', (e) => {
    //   this.activeFilters.type = e.target.value;
    //   this.applyFilters();
    // });
    
    // column with .sortable can sort value alpha
    this.querySelectorAll('.sortable').forEach(col => {
      col.addEventListener('click', () => {
        let index = Array.from(this.querySelectorAll('.op-table-header > div')).indexOf(col);
        this.sortRows(index, col.getAttribute('sort-type'));
        col.classList.toggle('asc', !col.classList.contains('asc'));
      });
    });
  }

  setRows(data) {
    this.rows = data;
    this.filteredRows = [...data];
    this.renderRows();
    this.updateCount();
  }

  filterRows(term) {
    const lower = term.toLowerCase();
    this.filteredRows = this.rows.filter(row =>
      row.some(val => val.toString().toLowerCase().includes(lower))
    );
    this.renderRows();
    this.updateCount();
  }

  applyFilters() {
    this.filteredRows = this.rows.filter(row => {
      // Search filter (applies to all columns)
      const searchMatch = !this.activeFilters.search || 
        row.some(val => val.toString().toLowerCase().includes(this.activeFilters.search.toLowerCase()));
      
      // Status filter (column index 6)
      const statusMatch = !this.activeFilters.status || row[6] === this.activeFilters.status;
      
      // Type filter (column index 3 - campaign name)
      const typeMatch = !this.activeFilters.type || row[3] === this.activeFilters.type;
      
      return searchMatch && statusMatch && typeMatch;
    });
    
    this.renderRows();
    this.updateCount();
  }

  sortRows(index, type) {
    // Track sort direction for each column
    if (!this.sortDirections) {
      this.sortDirections = {};
    }

    // Toggle sort direction for clicked column
    this.sortDirections[index] = !this.sortDirections[index];

    this.filteredRows.sort((a, b) => {
      const comparison = type === 'date' ? 
        (() => {
          // If both are blank, consider them equal
          if (!a[index] && !b[index]) return 0;
          // Blank dates always sort last
          if (!a[index] || a[index].trim() === '') return 1;
          if (!b[index] || b[index].trim() === '') return -1;
          // Try parsing dates in either "yyyy-mm-dd" or "dd-mm-yyyy"
          const parseDate = str => {
            // If already ISO format
            if (/^\d{4}-\d{2}-\d{2}$/.test(str.trim())) {
              return new Date(str.trim());
            }
            // If dd-mm-yyyy or d-m-yyyy
            let parts = str.trim().split('-');
            if (parts.length === 3) {
              // dd-mm-yyyy -> yyyy-mm-dd
              return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
            }
            // Fallback: let Date try to parse
            return new Date(str.trim());
          };
          const dateA = parseDate(a[index]);
          const dateB = parseDate(b[index]);
          // If one of them invalid, treat as blank
          if (isNaN(dateA)) return 1;
          if (isNaN(dateB)) return -1;
          return dateA - dateB;
        })()
        : a[index].localeCompare(b[index]);
      return this.sortDirections[index] ? comparison : -comparison;
    });

    this.renderRows();
  }

  updateCount() {
    const countEl = this.querySelector('#op-table-count');
    if (countEl) countEl.textContent = this.filteredRows.length;
  }

  renderRows() {
    const body = this.querySelector('#op-table-body');
    if (!body) return;

    body.innerHTML = this.filteredRows.map(row => `
      <div class="op-table-row">
        ${row.map(cell => `<div>${cell}</div>`).join('')}
      </div>
    `).join('');
  }
}

customElements.define('op-data-table', OpDataTable);
